import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { useSelector } from 'react-redux';
import queryString from 'query-string';
import moment from 'moment';

import {
  openrtbTimeStatistics,
  openrtbTimeStatisticsDetail,
} from 'lib/api/openrtb';
import {
  makeRowColumn,
  getHeadObj,
  converParameters,
  replaceZero,
  converDisplayValue,
  converUpDown,
  getHost,
} from 'lib/commonLib';

import MbTooltip from 'components/atoms/MbTooltip';
import NewButton from 'components/molecules/NewButton';
import NewTableContainer from 'components/molecules/NewTable';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import IconAreaWrap from 'components/molecules/MbTable/IconAreaWrap';
import NewCommonFilter from 'components/organisms/NewCommonFilter';

import RtbItlTpCodeFilter from './RtbItlTpCodeFilter';

const TimeStatistics = (props) => {
  const { location } = props;
  const { tp_code } = queryString.parse(location.search);
  const { common } = useSelector(({ common }) => ({ common: common }));

  const { t } = useTranslation();
  const { handlePortalUrl, commonCustomized } = props;

  const initParams = {
    order: 'STATS_HH',
    sort: 'desc',
    sDate: moment().format('YYYYMMDD'),
    eDate: moment().format('YYYYMMDD'),
    itlTpCode: !!tp_code ? tp_code : '04',
    pltfomTpCode: 'all',
  };

  const initCustomized = {
    ...commonCustomized,
    STATS_HH: {
      makeBody: (rowObj, headsMap) => {
        const isTotal = rowObj['FIXED'] !== 0;
        return isTotal ? rowObj['STATS_HH'] : t('합계');
      },
    },
    ADVRTS_AMT: {
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'ADVRTS_AMT');
        const bodyItem2 = getHeadObj(headsMap, 'RTB_TIME_RAF_RATE_ADVRTS_AMT');
        return (
          <>
            <MbTooltip title={t('09일 대비 10일의 등락')}>
              {makeRowColumn(
                rowObj['ADVRTS_AMT'],
                bodyItem1.type,
                bodyItem1.format
              )}{' '}
              <span className="black">(</span>
              {converUpDown(
                rowObj['RTB_TIME_RAF_RATE_ADVRTS_AMT'],
                bodyItem2.type,
                bodyItem2.format,
                false
              )}
              <span className="black">)</span>
            </MbTooltip>
          </>
        );
      },
    },
    RTB_TIME_RAF_RATE_ADVRTS_AMT: { merged: true },
    BID_REQ_CNT: {
      makeHead: (headsMap) => {
        return (
          <>
            {getHeadObj(headsMap, 'BID_REQ_CNT').label}
            <br />
            {getHeadObj(headsMap, 'BID_CNT').label}
            <br />
            {getHeadObj(headsMap, 'BID_RATE').label}
          </>
        );
      },
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'BID_REQ_CNT');
        const bodyItem2 = getHeadObj(headsMap, 'BID_CNT');
        const bodyItem3 = getHeadObj(headsMap, 'BID_RATE');
        return (
          <>
            {makeRowColumn(
              rowObj['BID_REQ_CNT'],
              bodyItem1.type,
              bodyItem1.format
            )}
            <br />
            {makeRowColumn(rowObj['BID_CNT'], bodyItem2.type, bodyItem2.format)}
            <br />
            {makeRowColumn(
              rowObj['BID_RATE'],
              bodyItem3.type,
              bodyItem3.format
            )}
          </>
        );
      },
      orderFlag: false,
    },
    BID_CNT: { merged: true },
    BID_RATE: { merged: true },
  };
  const [customized, setCustomized] = useState(initCustomized);
  const [initialization, setInitialization] = useState(false);
  const [params, setParams] = useState(initParams);
  const [tempParams, setTempParams] = useState(initParams);

  useEffect(() => {
    handleCustom(initParams);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    } // eslint-disable-next-line
  }, [initialization]);

  const handleOnReset = () => {
    if (
      JSON.stringify(params) !== JSON.stringify(initParams) ||
      JSON.stringify(tempParams) !== JSON.stringify(initParams)
    ) {
      setInitialization(true);
      setParams(initParams);
      setTempParams(initParams);
      handleCustom(initParams);
    }
  };

  const getParam = () => {
    if (JSON.stringify(params) !== JSON.stringify(tempParams)) {
      setParams(tempParams);
      handleCustom(tempParams);
    }
  };

  const getTableParam = (newParams, name) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
      setTempParams(newParams);
      handleCustom(newParams);
    }
  };

  const getTempParam = (newParams) => {
    if (JSON.stringify(tempParams) !== JSON.stringify(newParams)) {
      setTempParams(newParams);
    }
  };

  const makeSubParam = (data) => {
    console.log(data);
    return { ...params, statsHh: data.STATS_HH };
  };

  const handleCustom = (propsParams) => {
    let newCustomized = { ...initCustomized };
    newCustomized = {
      ...newCustomized,
      CLICK_CNT: {
        makeBody: (rowObj, headsMap) => {
          const bodyItem1 = getHeadObj(headsMap, 'CLICK_CNT');
          const isTotal = rowObj['FIXED'] !== 0;
          const data = makeRowColumn(
            rowObj['CLICK_CNT'],
            bodyItem1.type,
            bodyItem1.format
          );
          let showWindowUrl;
          if (isTotal && !rowObj['isChild']) {
            showWindowUrl = converParameters({
              url:
                getHost() + '/v2/openrtb/openrtb_time_mcode_report_popup.php',
              gb: converDisplayValue(
                common.productCodeList,
                propsParams['advrtsPrdtCode'],
                propsParams['advrtsTpCode']
              ),
              gb_web: replaceZero(propsParams['pltfomTpCode']),
              st_date: moment(propsParams['sDate']).format('YYYY-MM-DD'),
              en_date: moment(propsParams['eDate']).format('YYYY-MM-DD'),
              mcgb: 'R',
              tp_code: propsParams['itlTpCode'],
              stime: rowObj['STATS_HH'],
            });
          }
          return isTotal && !rowObj['isChild'] ? (
            <IconAreaWrap
              text={data}
              icon="faExternalLink"
              toolTipTitle={t('해당 RTB의 광고주별 통계')}
              onClick={(e) => handlePortalUrl(showWindowUrl)}
            />
          ) : (
            data
          );
        },
      },
    };
    setCustomized(newCustomized);
  };

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          params={tempParams}
          getParam={getTempParam}
          useExternalFilter={false}
          pltfomTpCodeDetailFilter={['04']}
          toolTip={t('매 30분 간격으로 데이터가 저장됩니다. (5분/35분)')}
        />
        <RtbItlTpCodeFilter params={tempParams} getTempParam={getTempParam} />
        <NewButton type="filterButton" onClick={getParam} disableRipple>
          {t('검색')}
        </NewButton>
      </NewFilterWrap>
      <NewTableContainer
        params={params}
        dataReqPromise={openrtbTimeStatistics}
        dataDetailReqPromise={openrtbTimeStatisticsDetail}
        makeSubParam={makeSubParam}
        getParam={getTableParam}
        customized={customized}
        expandTable
        isIncludingTotal
        useFetch={false}
        useSearch={false}
        rowsPerPage={-1}
        usePagenation={false}
      />
    </>
  );
};

export default withRouter(TimeStatistics);
